import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

import utils from '@/utils'

import jerseyDesign from './modules/jersey-design'

const modules = import.meta.glob('/src/views/**/**.{tsx,vue}')
const components: { [key: string]: Component } = utils.mapping(modules)

/**
 * 基础页面
 */
const basePage: RouteRecordRaw[] = [jerseyDesign]

/**
 * 登录页面
 */
const loginPage: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: components['login'],
    meta: {
      auth: []
    }
  }
]

const routes: RouteRecordRaw[] = [...basePage, ...loginPage]

// 重新组织后导出
export default routes
